<div class="bg-shui-base-2 p-4 rounded-md border border-shui-base-1 relative">
    <div
        class="flex justify-end items-center rounded-full z-20 cursor-pointer bg-shui-base-1 absolute -top-2 -right-2"
        (click)="onCancel()"
    >
        <sh-icon icon="cancel" button class="scale-[0.4]"></sh-icon>
    </div>
    <div class="flex flex-col gap-3 pt-4" [formGroup]="form">
        <sh-datepicker-accessor
            data-testid="settings-ooo-datepicker"
            [label]="
                ('common.out-of-office.manager.start-date' | translate) +
                ' - ' +
                ('common.out-of-office.manager.end-date' | translate)
            "
            formControlName="dateRange"
            [pastDateDisable]="true"
            [range]="true"
            [editable]="true"
            hint="MM/DD/YYYY-MM/DD/YYYY"
        ></sh-datepicker-accessor>
        <sh-user-picker
            data-testid="settings-ooo-input-coverage"
            [label]="'common.out-of-office.manager.coverage' | translate"
            [roles]="[roles.TASK_OWNER]"
            optionTestId="settings-ooo-option-coverage"
            formControlName="user"
        ></sh-user-picker>
        <div class="flex items-center justify-end gap-2 pt-1">
            @if (mode() === 'edit') {
                <sh-button
                    data-testid="settings-ooo-button-delete"
                    [label]="'common.general.delete' | translate"
                    color="tertiary"
                    size="max-content"
                    [disabled]="isSaving()"
                    (click)="onDelete()"
                ></sh-button>
            }
            <sh-button
                data-testid="settings-ooo-button-save"
                [label]="
                    mode() === 'create' ? ('common.general.create' | translate) : ('common.general.update' | translate)
                "
                size="max-content"
                [disabled]="isSaving()"
                [icon]="isSaving() ? 'loading' : null"
                icon-position="end"
                (click)="onUpdate()"
            ></sh-button>
        </div>
    </div>
</div>
